<template>
  <Layout>
    <div class="content is-size-7 p-md" v-if="state === undefined">
      <p class="is-size-5 has-text-white">
        {{ $t('Page visible only to registered users.') }}
      </p>
    </div>
    <div class="content is-size-7 p-md" v-else>
      <p class="is-size-5 has-text-white">
        {{ $t('Subscribed at') }} {{ new Date(state.openedAt).toLocaleString() }}
      </p>
      <p v-if="state.state === 'open'" class="is-size-5 has-text-white">
        {{ $t('Subscription active') }}
      </p>
      <p v-else class="is-size-5 has-text-white">
        {{ $t('Subscription closed at') }} {{ new Date(state.closedAt).toLocaleString() }}
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'
import axios from 'axios'

export default {
  name: 'Profile',
  data() {
    return {
      state: undefined
    }
  },
  components: {
    Layout
  },
  async mounted() {
    if (window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state !== 'unknown') {
        this.state = result.data
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/Profile.vue